import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  Avatar,
  Grid,
  Zoom,
  InputAdornment,
  TextField,
  Button,
  Pagination,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

// Import your images or use placeholders
import test from "../../assets/images/test.png";
import assessment from "../../assets/images/method.png";
import exam from "../../assets/images/exam.png";
import api from "../../api/client";
import { useSnackbar } from "../../providers/SnackbarProvider";
import { TableNodata } from "../../components/TableNodata";
import UpcomingProctoredAssessments from "./UpcomingProctoredAssessments";
import TopPerformers from "./TopPerformers";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useChangeableItems, getLabelByKey } from "../../store/useDynamicLabel";


const TrainerDashboard = () => {

  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);

  const [loaded, setLoaded] = useState(false);
  const currentMonth = dayjs().month();
  const currentYear = dayjs().year();

  const [selectedMonth] = useState(currentMonth);
  const [selectedYear] = useState(currentYear);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [testList, setTestList] = useState([]);
  const [listData, setListData] = useState([]);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  // assessment_info (old Question Paper Timeline) is no longer displayed; only the setter is kept
  const [, setAssessmentsDetail] = useState([]);
  const trainer = localStorage.getItem("role") === "TRAINER";
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();



  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const commonAvatarStyle = {
    bgcolor: "#e8f2ff",
    color: "#1e88e5",
    width: 24,
    height: 24,
    fontWeight: "bold",
    border: "2px solid #bbdefb",
  };

  const testData = async () => {
    try {
      const payload = {
        institute_id: +localStorage.getItem("InstituteId") || null,
        month: selectedMonth + 1 || null,
        year: selectedYear || null,
      };
      const res = await api.post("GetAllAssessmentsCountForTrainer", payload);
      setTestList(res?.data);
      setAssessmentsDetail(res?.data?.assessment_info || []);
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", "Fetching failed!");
    }
  };
  const studentAssessmentData = async () => {
    try {
      const payload = {
        page: page || 0,
        size: rowsPerPage || 100,
        search: search || "",
      };
      const res = await api.post("GetAllStudentAssessmentsForTrainer", payload);
      setListData(res?.data?.students || []);
      setCount(res?.data?.total_students || 0);
    } catch (error) {
      console.log("Error :", error);
      showSnackbar("error", "Fetching failed!");
    }
  };

  useEffect(() => {
    testData();
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    studentAssessmentData();
  }, [page, rowsPerPage, search]);

  // Check login status for conditional rendering
  const isLoggedIn = localStorage.getItem("logIn") !== "true";

  // Function to wrap content with Zoom conditionally.
  const ConditionalZoom = useCallback(({ children, style, key, in: inProp }) => {
    if (isLoggedIn) {
      return (
        <Zoom in={inProp} style={style} key={key}>
          {children}
        </Zoom>
      );
    }
    return children;
  }, [isLoggedIn]);

  return (
    <Box>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
              <DashboardIcon sx={{ color: "#1e88e5", fontSize: 32 }} />
              <Typography
                variant="h4"
                fontWeight={700}
                sx={{ color: "#0a0a0a" }}
              >
                Dashboard
              </Typography>
            </Box>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ mb: 4 }}
            >
              Overall summary of exam activities and {getLabel('STUDENT')}s' performance outcomes.
            </Typography>
          </Grid>
          {/* <Grid>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Month</InputLabel>
                  <Select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    input={
                      <OutlinedInput
                        label="Month"
                        startAdornment={
                          <InputAdornment position="start">
                            <CalendarMonthIcon />
                          </InputAdornment>
                        }
                      />
                    }
                  >
                    {months.map((month, index) => (
                      <MenuItem key={index} value={index}>
                        {month}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Year</InputLabel>
                  <Select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    input={
                      <OutlinedInput
                        label="Year"
                        startAdornment={
                          <InputAdornment position="start">
                            <CalendarMonthIcon />
                          </InputAdornment>
                        }
                      />
                    }
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid> */}
        </Box>

        {/* Cards Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
            flexWrap: "wrap",
            gap: 1,
            mb: 2,
          }}
        >
          {/* Total Tests Card */}
          <ConditionalZoom
            in={loaded}
            style={{ transitionDelay: "400ms" }}
            key="total-tests-card"
          >
            <Card
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 calc(40% - 16px)",
                  md: "1 1 calc(21% - 16px)",
                },
                borderRadius: "8px",
                border: "1px solid #c1c1c6ff",
                background: "#fff",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                p: 2,
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-4px) scale(1.03)",
                  boxShadow: "0px 6px 15px rgba(0,0,0,0.15)",
                  background: "linear-gradient(145deg, #f9fbff, #ffffff)",
                },
              }}
              onClick={() =>
                trainer
                  ? navigate("/questionPaperBuilder")
                  : navigate("/assesment", { state: { testTypeId: 0 } })
              }
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  sx={{ color: "#333", lineHeight: 1.1 }}
                >
                  {trainer ? ` No. of ${getLabel('QUESTION_PAPER')}` : `No. of ${getLabel('EXAM')}s`}
                </Typography>
                <Avatar sx={commonAvatarStyle}>
                  <Box
                    component="img"
                    src={test}
                    alt="Total Assessments"
                    sx={{ width: 26, height: 26 }}
                  />
                </Avatar>
              </Box>

              <Typography
                variant="h5"
                fontWeight={700}
                sx={{ color: "#1e88e5", mt: 1 }}
              >
                {testList?.total_assessments || "0"}
              </Typography>
            </Card>
          </ConditionalZoom>

          {/* Self Assessments Card */}
          <ConditionalZoom
            in={loaded}
            style={{ transitionDelay: "400ms" }}
            key="self-assessments-card"
          >
            <Card
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 calc(40% - 16px)",
                  md: "1 1 calc(21% - 16px)",
                },
                borderRadius: "8px",
                border: "1px solid #c1c1c6ff",
                background: "#fff",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                p: 2,
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-4px) scale(1.03)",
                  boxShadow: "0px 6px 15px rgba(0,0,0,0.15)",
                  background: "linear-gradient(145deg, #f9fbff, #ffffff)",
                },
              }}
              onClick={() =>
                trainer
                  ? navigate("/questionPaperBuilder", {
                    state: {
                      testType: "Self Assessment",
                      testTypeId: 1,
                    },
                  })
                  : navigate("/assesment", { state: { testTypeId: 1 } })
              }
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  sx={{ color: "#333", lineHeight: 1.1 }}
                >
                  {trainer
                    ? `No. of Self ${getLabel('EXAM')}s`
                    : `No. of Self ${getLabel('EXAM')}s`}
                </Typography>
                <Avatar sx={commonAvatarStyle}>
                  <Box
                    component="img"
                    src={assessment}
                    alt="Self Assessments"
                    sx={{ width: 26, height: 26 }}
                  />
                </Avatar>
              </Box>

              <Typography
                variant="h5"
                fontWeight={700}
                sx={{ color: "#1e88e5", mt: 1 }}
              >
                {testList?.total_self_assessments || "0"}
              </Typography>
            </Card>
          </ConditionalZoom>

          {/* Proctored Tests Card */}
          <ConditionalZoom
            in={loaded}
            style={{ transitionDelay: "400ms" }}
            key="proctored-tests-card"
          >
            <Card
              sx={{
                flex: {
                  xs: "1 1 100%",
                  sm: "1 1 calc(40% - 16px)",
                  md: "1 1 calc(21% - 16px)",
                },
                borderRadius: "8px",
                border: "1px solid #c1c1c6ff",
                background: "#fff",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                p: 2,
                transition: "all 0.3s ease",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-4px) scale(1.03)",
                  boxShadow: "0px 6px 15px rgba(0,0,0,0.15)",
                  background: "linear-gradient(145deg, #f9fbff, #ffffff)",
                },
              }}
              onClick={() =>
                trainer
                  ? navigate("/questionPaperBuilder", {
                    state: {
                      testType: "Proctored Assessment",
                      testTypeId: 2,
                    },
                  })
                  : navigate("/assesment", { state: { testTypeId: 2 } })
              }
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  sx={{ color: "#333", lineHeight: 1.1 }}
                >
                  {trainer
                    ? `No. of Proctored ${getLabel('EXAM')}s`
                    : `No. of Proctored ${getLabel('EXAM')}s`}
                </Typography>
                <Avatar sx={commonAvatarStyle}>
                  <Box
                    component="img"
                    src={exam}
                    alt="Proctored Tests"
                    sx={{ width: 26, height: 26 }}
                  />
                </Avatar>
              </Box>

              <Typography
                variant="h5"
                fontWeight={700}
                sx={{ color: "#1e88e5", mt: 1 }}
              >
                {testList?.total_proctored_assessments || "0"}
              </Typography>
            </Card>
          </ConditionalZoom>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
            border: "1px solid #c1c1c6ff",
            background: "#fff",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
            p: 2,
          }}
        >
          <ConditionalZoom
            in={loaded}
            style={{ transitionDelay: "400ms" }}
            key="performance-overview-header"
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 1,
              }}
            >
              <Grid
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <SchoolOutlinedIcon sx={{ color: "#1e88e5", fontSize: 28 }} />
                <Typography variant="h6" fontWeight={700}>
                  {trainer
                    ? `${getLabel('STUDENT')}s performance Overview`
                    : `${localStorage.getItem(
                      "firstName",
                    )}'s performance Overview`}
                </Typography>
              </Grid>

            </Grid>
          </ConditionalZoom>

          {/* Top Performers Section — side by side on wide screens, stacked on narrow ones */}
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 3 }}>
            {/* Top Performers Card */}
            <ConditionalZoom
              in={loaded}
              style={{ transitionDelay: "800ms" }}
              key="top-performers-card"
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <TopPerformers
                  showTestTypeFilter
                  canOpen={(item) => trainer || item?.test_type === "Self Assessment"}
                />
              </Box>
            </ConditionalZoom>

            <ConditionalZoom
              in={loaded}
              style={{ transitionDelay: "800ms" }}
              key="upcoming-proctored-assessments-card"
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                {/* Trainer: his students' tests; Student: tests assigned to him (backend decides from the token).
                    Only Trainers can open the question paper, as before. */}
                <UpcomingProctoredAssessments showTestTypeFilter clickable={trainer} />
              </Box>
            </ConditionalZoom>
          </Box>
        </Box>

        {/* Student Exams Overview Section (only for trainers) */}
        {trainer && (
          <ConditionalZoom
            in={loaded}
            style={{ transitionDelay: "1200ms" }}
            key="student-exams-overview"
          >
            <Box
              sx={{
                mt: 3,
                borderRadius: "8px",
                border: "1px solid #c1c1c6ff",
                background: "#fff",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                p: 3,
                overflowX: "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <SchoolOutlinedIcon sx={{ color: "#1e88e5", fontSize: 28 }} />
                  <Typography variant="h6" fontWeight={700}>
                    {getLabel('STUDENT')} {getLabel('EXAM')} Overview
                  </Typography>
                </Grid>
                <TextField
                  value={search}
                  onChange={(e) => {
                    setPage(0);
                    setSearch(e.target.value);
                  }}
                  size="small"
                  variant="outlined"
                  placeholder={`Search ${getLabel('STUDENT')}s`}
                  className="custom-search-field"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Grid
                container
                sx={{
                  py: 1.5,
                  borderBottom: "1px solid #e0e0e0",
                  fontWeight: 600,
                  color: "text.secondary",
                  flexWrap: "nowrap",
                  minWidth: 880,
                }}
              >
                <Grid item xs={4} sx={{ width: "16%" }}>
                  {getLabel('STUDENT')}s
                </Grid>
                <Grid item xs={2} sx={{ width: "16%" }}>
                  {getLabel('QUESTION_PAPER')}s (SA)
                </Grid>
                <Grid item xs={2} sx={{ width: "16%" }}>
                  {getLabel('QUESTION_PAPER')}s (PA)
                </Grid>
                <Grid
                  item
                  xs={2}
                  sx={{ width: "16%", textAlignLast: "center" }}
                >
                  {getLabel('EXAM')} Taken (SA)
                </Grid>
                <Grid
                  item
                  xs={2}
                  sx={{ width: "20%", textAlignLast: "center" }}
                >
                  {getLabel('EXAM')} Taken (PA)
                </Grid>
                <Grid item xs={2} sx={{ width: "16%" }}>
                  Status
                </Grid>
              </Grid>

              {listData.map((student, index) => (
                <Grid
                  container
                  key={`student-${index}`}
                  alignItems="center"
                  sx={{
                    py: 1.5,
                    borderBottom: "1px solid #f2f2f2",
                    "&:hover": { backgroundColor: "#fafafa" },
                    flexWrap: "nowrap",
                    minWidth: 880,
                  }}
                >
                  <Grid
                    item
                    xs={4}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      width: "16%",
                    }}
                  >
                    <Avatar sx={commonAvatarStyle}>
                      {student?.first_name?.charAt(0).toUpperCase()}
                    </Avatar>
                    <Box>
                      <Typography fontWeight={600}>{student.name}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {student.email}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.5,
                      width: "16%",
                    }}
                    onClick={() =>
                      navigate("/questionPaperBuilder", {
                        state: {
                          testType: "Self Assessment",
                          testTypeId: 1,
                          studentId: student?.student_user_id,
                          studentName: student?.name,
                        },
                      })
                    }
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{ color: "#1e88e5", fontSize: 20 }}
                      />
                      <Typography fontWeight={500}>
                        {student.total_assigned_self_assessments}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.5,
                      width: "16%",
                    }}
                    onClick={() =>
                      navigate("/questionPaperBuilder", {
                        state: {
                          testType: "Proctored Assessment",
                          testTypeId: 2,
                          studentId: student?.student_user_id,
                          studentName: student?.name,
                        },
                      })
                    }
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{ color: "#1e88e5", fontSize: 20 }}
                      />
                      <Typography fontWeight={500}>
                        {student.total_assigned_proctored_assessments}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.5,
                      width: "16%",
                    }}
                    onClick={() =>
                      navigate("/examHistory", {
                        state: {
                          dashboard: true,
                          testType: "Self Assessment",
                          testTypeId: 1,
                        },
                      })
                    }
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{ color: "#1e88e5", fontSize: 20 }}
                      />
                      <Typography fontWeight={500}>
                        {student.self_assessments_completed}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 0.5,
                      width: "20%",
                    }}
                    onClick={() => (
                      navigate("/examHistory", {
                        state: {
                          dashboard: true,
                          testType: "Proctored Assessment",
                          testTypeId: 2,
                          testId: 2,
                        },
                      }),
                      localStorage.setItem("TabValue", 1)
                    )}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{ color: "#1e88e5", fontSize: 20 }}
                      />
                      <Typography fontWeight={500}>
                        {student.proctored_assessments_completed}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={2} sx={{ width: "16%" }}>
                    <Box
                      sx={{
                        display: "inline-block",
                        px: 2,
                        py: 0.5,
                        borderRadius: "12px",
                        fontWeight: "bold",
                        fontSize: "12px",
                        backgroundColor:
                          student.status === "ACTIVE" ? "#d4edda" : "#f8d7da",
                        color:
                          student.status === "ACTIVE" ? "#155724" : "#721c24",
                        textAlign: "center",
                      }}
                    >
                      {student.status}
                    </Box>
                  </Grid>
                </Grid>
              ))}

              {listData.length === 0 && (
                <Box sx={{ py: 4, textAlign: "center" }}>
                  <TableNodata />
                </Box>
              )}

              {((page === 0 && listData?.length > rowsPerPage - 1) ||
                page !== 0) && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 2,
                    }}
                  >
                    {page !== 0 ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Button
                          variant="outlined"
                          startIcon={
                            <ArrowBackIcon
                              sx={{
                                color: page === 0 ? "#a2a2a2" : "#414651",
                              }}
                            />
                          }
                          disabled={page === 0}
                          onClick={() => setPage(page - 1)}
                          sx={{
                            borderRadius: "12px",
                            textTransform: "none",
                            color: page === 0 ? "#a2a2a2" : "#414651",
                            borderColor: "#d0d0d0",
                          }}
                        >
                          Previous
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ width: "110px" }} />
                    )}

                    <Pagination
                      page={page + 1}
                      onChange={(e, value) => setPage(value - 1)}
                      count={Math.ceil(count / rowsPerPage)}
                      siblingCount={3}
                      boundaryCount={3}
                      shape="rounded"
                      hidePrevButton
                      hideNextButton
                    />
                    {page + 1 !== Math.ceil(count / rowsPerPage) ? (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Button
                          variant="outlined"
                          endIcon={
                            <ArrowForwardIcon
                              sx={{
                                color: page + 1 === count ? "#a2a2a2" : "#414651",
                              }}
                            />
                          }
                          disabled={page + 1 === count}
                          onClick={() => setPage(page + 1)}
                          sx={{
                            borderRadius: "12px",
                            textTransform: "none",
                            color: page + 1 === count ? "#a2a2a2" : "#414651",
                            borderColor: "#d0d0d0",
                          }}
                        >
                          Next
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ width: "110px" }} />
                    )}
                  </Box>
                )}
            </Box>
          </ConditionalZoom>
        )}
      </Box>
    </Box>
  );
};

export default TrainerDashboard;
